import { Dispatch, SetStateAction, useEffect } from 'react';
import { StateMethods } from '@hookstate/core';
import { useInfiniteQuery } from 'react-query';
import { useInView } from 'react-intersection-observer';

import { getTags } from '@services/queries/tags';
import { ITagCategory } from '@models/TagCategory.model';

import Rolling from '@assets/gif/rolling.gif';

import { ITag } from '@models/Tag.model';
import { TagRow } from '../TagsManagement/Components/TagRow/TagRow';

import {
  Container,
  LoadingImg,
  LoadingText,
  LoadMore,
} from './TagsList.styles';

interface ITagsList {
  tagCategoryId: string;
  searchText: string;
  sort: string | undefined;
  direction?: 'ASC' | 'DESC' | undefined;
  isManage: boolean;
  tagCategory: ITagCategory;
  toggleCheckBox: (id: string) => void;
  setOpenMoveTagDialog: Dispatch<SetStateAction<boolean>>;
  setTagId: Dispatch<SetStateAction<string[]>>;
  openDeleteTagDialog: StateMethods<boolean>;
  checked: string[];
  toggleSelectedTags: (Tag: ITag) => void;
}

const TagsList = ({
  direction,
  sort,
  searchText,
  tagCategoryId,
  isManage,
  toggleCheckBox,
  tagCategory,
  checked,
  openDeleteTagDialog,
  setTagId,
  setOpenMoveTagDialog,
  toggleSelectedTags,
}: ITagsList) => {
  const {
    data,
    isLoading,
    isError,
    fetchNextPage: newFetchNextPage,
  } = useInfiniteQuery(
    ['tagCategories', tagCategoryId, 'tags', searchText, sort, direction],
    async ({ pageParam = 1 }) => {
      const tagsList = await getTags({
        pagination: {
          page: pageParam,
          limit: 20,
          search: searchText,
        },
        filter: { tagCategoryId, sort, direction },
      });
      return tagsList;
    },
    {
      getPreviousPageParam: undefined,
      getNextPageParam: lastPage =>
        lastPage.hasMore ? lastPage.currentPage + 1 : undefined,
    },
  );

  const tagsData = data
    ? data.pages
        .map(pageData => pageData.results)
        .reduce(function reduce(prev, next) {
          return prev.concat(next);
        })
    : [];

  const hasMore = data ? data.pages[data.pages.length - 1].hasMore : false;

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasMore) newFetchNextPage();
  }, [inView, hasMore]);

  if (!data || isError) {
    <div>error</div>;
  }
  if (isLoading) {
    <div />;
  }
  return (
    <Container>
      {tagsData.map(tag => {
        const isChecked = !!checked.find(item => item === tag.id);
        return (
          <TagRow
            isManage={isManage}
            tags={tag}
            tagCategory={tagCategory}
            toggleCheckBox={toggleCheckBox}
            toggleSelectedTags={toggleSelectedTags}
            isChecked={isChecked}
            setOpenMoveTagDialog={setOpenMoveTagDialog}
            setTagId={setTagId}
            openDeleteTagDialog={openDeleteTagDialog}
          />
        );
      })}
      <LoadMore ref={ref}>
        {hasMore ? (
          <LoadMore>
            <LoadingText>Loading more</LoadingText>
            <LoadingImg src={Rolling} alt="loading" />
          </LoadMore>
        ) : (
          <div />
        )}
      </LoadMore>
    </Container>
  );
};

export { TagsList };
